module.exports = __webpack_public_path__ + "static/media/img_fileupload.76103c13.svg";